export var getLoaderSize = function getLoaderSize(size) {
  if (size === 'l') {
    return 's';
  }
  if (size === 'm') {
    return 'xs';
  }
  return 'xxs';
};